import { render, staticRenderFns } from "./Rents.vue?vue&type=template&id=38d91f1c"
import script from "./Rents.vue?vue&type=script&lang=js"
export * from "./Rents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports